import React, { PureComponent } from "react";
import {
  Row,
  Alert,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";
import { UploadFile } from "../../Shared/FileUpLoad";
import { DatePicker } from "../../Shared/Forms/DateTimePicker";
import DealCategoryDropdown from "../DealsCategory/DealCategoryDropDown";
import MerchantDropdown from "../Merchants/MerchantDropdown";
import { dateTimeutils } from "../../../_utils";
import LocationInput from "../Merchants/LocationInput";

class DealsForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      startDateAt: null,
      endDateAt: null,
      actionType: false,
      notExpired: true
    };
   
  }

  onChange = e => {
    if (e.startAt !== undefined) {
      if (e.startAt !== null) {
        this.setState({ startDateAt: e.startAt });
      }
      if (e.startAt === null) {
        this.setState({ startDateAt: undefined });
      }
    }
    if (e.endAt !== undefined) {
      if (e.endAt !== null && e.startAt === undefined) {
        this.setState({ endDateAt: e.endAt });
      }
      if (e.endAt === null) {
      

        this.setState({
          endDateAt: undefined,
          actionType: false
          
        });
      }
    }
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  getImageData = ImageURL => {
    let block = ImageURL.split(";");
    let realData = block[1].split(",")[1];
    return realData;
  };

  handleSubmit = data => {
    data = {
      ...data,
      imageBase64: this.getImageData(data.imageBase64),
      categoryId: data.categoryId.id,
      merchantId: data.merchantId.id,
      startAt: dateTimeutils.isoDate(data.startAt),
      endAt: dateTimeutils.isoDate(data.endAt),
      url: data.url ? data.url : ""
    };
    this.props.submitAction(data);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.action === "view") {
      this.setState({ actionType: false, notExpired: true });
    }
    if (nextProps.action === "edit") {
      if (
        dateTimeutils.checkDate(
          new Date(nextProps.selectedRow && nextProps.selectedRow.endAt)
        )
      ) {
        this.setState({ actionType: true, notExpired: false });
      } else {
        this.setState({ actionType: false, notExpired: true });
      }
    }
    if (nextProps.imageUrl && nextProps.action === "edit") {
      this.imageId.toDataURL(this.props.imageUrl, result =>
        this.imageId.props.setValue(result)
      );
    }

    if (nextProps.submitted) {
      
      this.reset();
    }
  }

  resetForm = () => {
    this.refs.dealForm.reset();
    if (this.startAt && this.endAt) {
      this.startAt.changeValue(null);
      this.endAt.changeValue(null);
    }
    if (this.imageId) {
      this.imageId.cancelImage();
    }
  };

  reset = () => {
    this.resetForm();
    this.props.reset();
  };

  render() {
    const {
      canSubmit,
      startDateAt,
      endDateAt,
      actionType,
      notExpired
    } = this.state;

    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      isView,
      imageUrl,
      locationState,
      setImageNull,
      fetchingRow,
      getMerchantLocations,
      fetchingError,
      locationViewState,
      isDeleteButton

      
    } = this.props;

    const startAt = this.startAt && this.startAt.state.date;
    const endAt = this.endAt && this.endAt.state.date;

    return (
      <div>
        <Row>
          <Col>
            <Card>
              <CardHeader>{hasParams ? "Edit" : "Create"} Deal</CardHeader>
              <CardBody>
                {error && !error.errors ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                {error && error.errors && error.errors.length ? (
                  <UncontrolledAlert color="danger">
                    {error.errors.map((error, index) => (
                      <p key={index}>
                        {error.message === "must be a future date" ? (
                          <strong>
                            End Date: Field must be a future date{" "}
                          </strong>
                        ) : (
                          <strong>
                            {error.field}:{error.message}
                          </strong>
                        )}
                      </p>
                    ))}
                  </UncontrolledAlert>
                ) : null}
                {fetchingError ? (
                  <UncontrolledAlert color="danger">
                    {fetchingError.message}
                  </UncontrolledAlert>
                ) : null}

                {fetchingRow && (
                  <Alert color="info">
                    <Spinner message="Fetching deal details" />
                  </Alert>
                )}
                <Formsy
                  ref="dealForm"
                  onChange={this.onChange}
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="name"
                    value={selectedRow && hasParams ? selectedRow.name : null}
                    required
                    disabled={submitting || isView || fetchingRow}
                    title="Name"
                    validations={{
                      minLength: 3,
                      maxLength: 50
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />
                  <TextInput
                    name="description"
                    type="textarea"
                    required
                    value={
                      hasParams && selectedRow ? selectedRow.description : null
                    }
                    disabled={submitting || isView || fetchingRow}
                    title="Description"
                    validations={{
                      minLength: 5
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />
                  <TextInput
                    name="url"
                    value={selectedRow && hasParams ? selectedRow.url : ""}
                    subtitle="
( Example:http://www.example.com )"
                    type="url"
                    disabled={submitting || isView || fetchingRow}
                    title="Deal URL"
                    validations={{
                      minLength: 3,
                      isUrl: true
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      isUrl: "Please enter a valid URL"
                    }}
                  />
                  <DealCategoryDropdown
                    isClearable={true}
                    value={
                      selectedRow && hasParams
                        ? {
                            id: selectedRow.categoryId,
                            name: selectedRow.categoryName
                          }
                        : null
                    }
                    selectedMetrics
                    valueKey="id"
                    disabled={submitting || isView || fetchingRow}
                    innerRef={c => {
                      this.category = c;
                    }}
                    isRequired={true}
                    name="categoryId"
                    title="Category
                    "
                  />
                  <MerchantDropdown
                    isClearable={true}
                    value={
                      selectedRow && hasParams
                        ? {
                            id: selectedRow.merchantId,
                            name: selectedRow.merchantName
                          }
                        : null
                    }
                    valueKey="id"
                    disabled={submitting || isView || fetchingRow}
                    innerRef={c => {
                      this.merchant = c;
                    }}
                    onChange={getMerchantLocations}
                    isRequired={true}
                    name="merchantId"
                    title="Merchant"
                  />
                  <LocationInput
                    name="locations"
                    isView={isView}
                    formState={locationState}
                    viewState={locationViewState}
                    merchantId={!!selectedRow && selectedRow.id}
                  />
                  <DatePicker
                    name="startAt"
                    id="startAt"
                    required
                    label="Start Date"
                    title="Start Date"
                    startDate={startAt}
                    endDate={endAt}
                    minDate={new Date()}
                    maxDate={endDateAt}
                    isStart={true}
                    isEnd={false}
                    isTime={true}
                    isNotClearable={isView || !notExpired ? true : false}
                    disabled={
                      submitting || isView || !notExpired || fetchingRow
                    }
                    defaultValue={
                      hasParams && selectedRow && selectedRow.startAt 
                    
                    }
                    innerRef={c => {
                      this.startAt = c;
                    }}
                  />
                  <DatePicker
                    id="endAt"
                    name="endAt"
                    required
                    label="End Date"
                    title="End Date"
                    startDate={startAt}
                    endDate={endAt}
                    minDate={
                      notExpired ? startDateAt || new Date() : new Date()
                    }
                    maxDate={endAt}
                    isStart={false}
                    isEnd={true}
                    isTime={true}
                    isNotClearable={isView ? true : false}
                    disabled={submitting || isView || fetchingRow}
                    defaultValue={hasParams && selectedRow && selectedRow.endAt}
                    innerRef={c => {
                      this.endAt = c;
                    }}
                    validations={{
                      myCustomIsFiveValidation: function() {
                        if (
                          actionType &&
                          selectedRow &&
                          selectedRow.endAt !== null
                        ) {
                          if (
                            dateTimeutils.checkDate(
                              new Date(selectedRow && selectedRow.endAt)
                            )
                          ) {
                            return "Deal has expired please update your deal end date";
                          } else {
                            return true;
                          }
                        } else {
                          return true;
                        }

                    
                      }
                    }}
                 
                  />
                  <UploadFile
                    name="imageBase64"
                    type="file"
                    acceptedFormats={"jpg|jpeg|png|gif"}
                    required
                    disabled={submitting || isView || fetchingRow}
                    value={imageUrl || null}
                    innerRef={c => {
                      this.imageId = c;
                    }}
                    maxSize={1048576}
                    imageUrl={imageUrl && !isDeleteButton ? imageUrl : null} 
                    setImageNull={setImageNull}
                    dontShowCancelButton={true}
                    title={isView ? null : "Deal Image"}
                    isView={isView}
                    isUpLoading={false}
                  />
                  <TextInput
                    name="termsAndConditions"
                    type="textarea"
                    required
                    value={
                      hasParams && selectedRow
                        ? selectedRow.termsAndConditions
                        : null
                    }
                    disabled={submitting || isView || fetchingRow}
                    title="Terms and Conditions"
                    validations={{
                      minLength: 5
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />
                  {!isView ? (
                    <Button
                      type="submit"
                      color="primary"
                      disabled={!canSubmit || submitting || isView}
                      className="pp3"
                    >
                      {submitting ? (
                        <Spinner size="sm" />
                      ) : (
                        <span>
                          {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                        </span>
                      )}
                    </Button>
                  ) : null}{" "}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.reset()}
                      className="mr-1"
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DealsForm;
